import { render, staticRenderFns } from "./HistoricoEventosDlg.vue?vue&type=template&id=63503263"
import script from "./HistoricoEventosDlg.vue?vue&type=script&lang=js"
export * from "./HistoricoEventosDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports